export const formatCurrency = (number: number) =>
  Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number);

export const byOrder = <T extends { order: number }>(categoryA: T, categoryB: T) => categoryA.order - categoryB.order;
